const sleep = (ms = 0) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
export {
  sleep as s
};
//# sourceMappingURL=sleep-94ff03e6.mjs.map
